import {
    Banner as PropsBanner,
    Selector as PropsSelector,
} from '@/models/Props';

import './Header.scss';
import { LanguageBox } from '@/components/blocks';
import useStore from '@/stores/useStore';
import LogoIcon from '../../../assets/co2logic-logo.svg';

const Header = ({ alt, ariaLabel }: PropsBanner & PropsSelector) => {
    const data = useStore((state) => state.data);

    return (
        <header aria-label={ariaLabel} className={'header-container'}>
            <img className='background-image' src={data?.branding![0]?.headerImage?.URL} />

            <div className='logo-wrapper'>
                <img src={LogoIcon} alt="" style={{ height: '45px' }} />
                <LanguageBox />
            </div>
        </header>
    );
};

export default Header;
